import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { ReactComponent as FreezingCycle } from '../../../assets/icons/freezing-cycle.svg';
import NewButton from '../../../components/Button/NewButton';
import OutlineButton from '../../../components/Button/OutlineButton';

import { PatientPackage } from 'kb-shared';

import { typography, cardBoxShadow } from '../../../styled';

const {
  serif: {
    card: { H2 }
  },
  sans: {
    copy: { Small }
  }
} = typography;

const FreezingCycleContainer = styled.div`
  height: 48px;
  width: 48px;
`;

const Content = styled.div`
  align-items: center;
  box-shadow: ${cardBoxShadow};
  display: flex;
  flex-direction: column;
  padding: 20px 20px 40px 20px;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 40px;
`;

const Explainer = styled(Small)`
  margin-top: 0;
  margin-bottom: 30px;
`;

const OutlinButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

type Props = {
  boughtCycle: PatientPackage;
};

const CycleConfirmation = (props: Props) => {
  const {
    boughtCycle: {
      // @ts-ignore
      appointmentPackage: { quantity }
    }
  } = props;
  const history = useHistory();

  return (
    <>
      <Content id="google-tag-manager-confirmation">
        <FreezingCycleContainer>
          <FreezingCycle />
        </FreezingCycleContainer>
        <H2>{`${quantity} cycle${quantity > 1 ? 's' : ''}`}</H2>
        <Explainer>Schedule an appointment to begin the stimulation phase</Explainer>
        <NewButton
          text="Book an appointment"
          onClick={() => {
            history.replace('/booking-quiz');
          }}
        />
      </Content>
      <OutlinButtonContainer>
        <OutlineButton
          text="Go to dashboard"
          onClick={() => {
            history.replace('/');
          }}
        />
      </OutlinButtonContainer>
    </>
  );
};

export default CycleConfirmation;
